module.exports = __webpack_public_path__ + "41389c7b6c8928b7fa23199662cd5e54.pdf";